import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setMessage } from '../../../redux/slice';

import * as api from '../api';

export const doGetOrders = createAsyncThunk<any, any>('orders/doGetOrders', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getOrders(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetOrder = createAsyncThunk('orders/doGetOrder', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.getOrder(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetOrderByDBId = createAsyncThunk('orders/doGetOrderByDBId', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getOrderByDBId(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateOrder = createAsyncThunk('orders/doCreateOrder', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.createOrder(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doImportOrders = createAsyncThunk('orders/doImportOrders', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.importOrders(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUploadOrdersFromFile = createAsyncThunk('orders/doUploadOrdersFromFile', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.uploadOrdersFromFile(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateOrder = createAsyncThunk('orders/doUpdateOrder', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.updateOrder(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
export const doCancelOrder = createAsyncThunk('orders/doCancelOrder', async (params: any, thunkAPI) => {
  try {
    const { response, error } = await api.cancelOrder(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
export const doRetryOrderAddress = createAsyncThunk('orders/doRetryOrderAddress', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.retryOrderAddress(params);

    if (response.status === 'REJECTED') {
      // show error but handle as fulfilled
      thunkAPI.dispatch(setError(new Error('The retried order was rejected.')));
      return response;
    }

    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doRetryOrder = createAsyncThunk<any, any>('orders/doRetryOrder', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.retryOrder(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateOrdersBatch = createAsyncThunk('orders/doUpdateOrdersBatch', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.updateOrdersBatch(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteOrder = createAsyncThunk<any, any>('orders/doDeleteOrder', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.deleteOrder(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteOrders = createAsyncThunk('orders/doDeleteOrders', async (data, thunkAPI) => {
  try {
    const { response, error } = await api.deleteOrders(data);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
